import { getFunctions, httpsCallable } from "firebase/functions";

const fn = (name) => httpsCallable(getFunctions(), name);

export const OutreachAgent = {
  async generate(lead, research, signupUrl, demoBookingUrl, voiceSamples) {
    const call = fn("growthGenerateOutreach");
    const result = await call({
      lead,
      research,
      signupUrl: signupUrl || "https://pebbletheapp.com/signup",
      demoBookingUrl: demoBookingUrl || null,
      voiceSamples: voiceSamples || [],
    });
    return result.data.outreach;
  },

  async generateFollowUp(lead, research, previousOutreach, daysSinceLast) {
    const call = fn("growthGenerateFollowUp");
    const result = await call({ lead, research, previousOutreach, daysSinceLast });
    return result.data.followUp;
  },
};
